import {
    Callout,
    DefaultPalette,
    FocusZone,
    FocusZoneDirection,
    Label,
    List,
    mergeStyleSets,
    SearchBox,
    Text,
    TextField
} from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
import { RootState } from 'app/store';
import { appStyles } from 'global/Application';
import React, { useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';

export const DefaultColors = {
    Application: {
        Primary: '#0078d7',
        Secondary: '#e5e5e5',
        LightBackground: '#ffffff',
        NeutralBackground: '#e5e5e5'
    },
    VisualIndicators: {
        GrayIndicator: '#7a7574',
        GreenIndicator: '#498205',
        YellowIndicator: '#fce100',
        RedIndicator: '#d1343b',
        BlueIndicator: '#0078d7'
    },
    Text: {
        Header: DefaultPalette.neutralPrimary,
        Primary: DefaultPalette.neutralPrimary,
        Secondary: DefaultPalette.neutralSecondary,
        HeroAccent: '#0078D7',
        Error: DefaultPalette.redDark
    },
    Link: {
        PrimaryLink: DefaultPalette.themePrimary,
        HeroLink: DefaultPalette.themeDark,
    },
    List: {
        HeaderText: DefaultPalette.neutralSecondary,
        RowText: DefaultPalette.neutralPrimary,
    },
    Item: {
        ListItemHoverBackgroundColor: DefaultPalette.neutralLighterAlt,
        ItemIndicator: '#0078d7'
    },
    Icon: {
        SecondaryIcon: DefaultPalette.neutralSecondary,
        PrimaryIcon: DefaultPalette.neutralPrimary
    }
};

interface IProps extends TComponentConnectedProps {

}


export interface IItem {
    key: number;
    display: string;
    search: string;
    data?: any;
}

export const SuggestionListItemStyle = mergeStyleSets({
    root: {
        selectors: {
            '&:hover': {
                backgroundColor: DefaultColors.Item.ListItemHoverBackgroundColor
            }
        }
    }

});


const KeyCodes = {
    tab: "Tab",
    enter: 13 as 13,
    arrowDown: "ArrowDown"
}


const AutoComplete: React.FC<IProps> = (props) => {
    const [visible, setVisible] = useState(false);
    const [search, setSearch] = useState('');
    const [selectedItem, setSelectedItem] = useState<IItem | null>(null);
    const id = useId('callout-cost-share');

    const searchData: IItem[] = [
        { key: 1, display: 'Alabama', search: 'Alabama' },
        { key: 2, display: 'Alaska', search: 'Alaska' },
        { key: 3, display: 'Arizona', search: 'Arizona' },
        { key: 4, display: 'Arkansas', search: 'Arkansas' },
        { key: 5, display: 'California', search: 'California' },
        { key: 6, display: 'Colorado', search: 'Colorado' },
        { key: 7, display: 'Connecticut', search: 'Connecticut' },
        { key: 8, display: 'Delaware', search: 'Delaware' },
        { key: 9, display: 'Florida', search: 'Florida' },
        { key: 10, display: 'Georgia', search: 'Georgia' },
        { key: 11, display: 'Hawaii', search: 'Hawaii' },
        { key: 12, display: 'Idaho', search: 'Idaho' },
        { key: 13, display: 'Illnois', search: 'Illnois' },
        { key: 14, display: 'Indiana', search: 'Indiana' },
        { key: 15, display: 'Iowa', search: 'Iowa' },
        { key: 16, display: 'Kansas', search: 'Kansas' },
        { key: 17, display: 'Kentucky', search: 'Kentucky' },
        { key: 18, display: 'Louisiana', search: 'Louisiana' },
        { key: 19, display: 'Maine', search: 'Maine' },
        { key: 20, display: 'Maryland', search: 'Maryland' },
        { key: 21, display: 'Massachusetts', search: 'Massachusetts' },
        { key: 22, display: 'Michigan', search: 'Michigan' },
        { key: 23, display: 'Minnesota', search: 'Minnesota' },
        { key: 24, display: 'Mississippi', search: 'Mississippi' },
        { key: 25, display: 'Missouri', search: 'Missouri' },
        { key: 26, display: 'Montana', search: 'Montana' },
        { key: 27, display: 'Nebraska', search: 'Nebraska' },
        { key: 28, display: 'Nevada', search: 'Nevada' },
        { key: 29, display: 'New Hampshire', search: 'New Hampshire' },
        { key: 30, display: 'New Jersey', search: 'New Jersey' },
        { key: 31, display: 'New Mexico', search: 'New Mexico' },
        { key: 32, display: 'New York', search: 'New York' },
        { key: 33, display: 'North Carolina', search: 'North Carolina' },
        { key: 34, display: 'North Dakota', search: 'North Dakota' },
        { key: 35, display: 'Ohio', search: 'Ohio' },
        { key: 36, display: 'Oklahoma', search: 'Oklahoma' },
        { key: 37, display: 'Oregon', search: 'Oregon' },
        { key: 38, display: 'Pennsylvania', search: 'Pennsylvania' },
        { key: 39, display: 'Rhode Island', search: 'Rhode Island' },
        { key: 40, display: 'South Carolina', search: 'South Carolina' },
        { key: 41, display: 'South Dakota', search: 'South Dakota' },
        { key: 42, display: 'Tennessee', search: 'Tennessee' },
        { key: 43, display: 'Texas', search: 'Texas' },
        { key: 44, display: 'Utah', search: 'Utah' },
        { key: 45, display: 'Vermont', search: 'Vermont' },
        { key: 46, display: 'Virginia', search: 'Virginia' },
        { key: 47, display: 'Washington', search: 'Washington' },
        { key: 48, display: 'West Virginia', search: 'West Virginia' },
        { key: 49, display: 'Wisconsin', search: 'Wisconsin' },
        { key: 50, display: 'Wyoming', search: 'Wyoming' },
    ].filter(q => q.search.toLowerCase().indexOf(search) > -1)
        .slice(0, 6);

    const suggest = () => {
        return (
            <FocusZone direction={FocusZoneDirection.vertical}>
                <List
                    id={'SearchList'}
                    tabIndex={-1}
                    items={searchData}
                    onRenderCell={(item, index, isScrolling) => {
                        if (item && item.key)
                            return (
                                <div
                                    key={item.key}
                                    id={'item' + index}
                                    className={SuggestionListItemStyle.root}
                                    data-is-focusable={true}
                                >
                                    <div
                                        style={{ padding: '4px 16px' }}
                                        onClick={() => { setSelectedItem(item); }}

                                    >
                                        <Text variant='mediumPlus'>{item.display}</Text>
                                    </div>
                                </div>
                            );
                    }}
                />
            </FocusZone>
        );
    }

    return (
        <div id={id}
            onBlur={(event) => {
                // if the blur was because of outside focus
                // currentTarget is the parent element, relatedTarget is the clicked element
                if (!event.currentTarget.contains(event.relatedTarget)) {

                } else {
                    // if (visible)
                    // setVisible(false);
                }

            }}
        >
            <Label>Cost Share</Label>
            <TextField value={selectedItem?.display} />
            <SearchBox
                autoComplete='off'
                value={selectedItem ? selectedItem.display : undefined}
                onBlur={(event) => {
                    // if (visible)
                    //     setVisible(false);
                }}
                onChange={(event, newValue) => {
                    if (!visible)
                        setVisible(true);

                    setSearch(newValue?.toLowerCase() ?? '');
                }}
                onMouseEnter={() => {
                }}
                onKeyDown={(event) => {
                    if (event.key === KeyCodes.arrowDown) {

                        let el: any = window.document.querySelector("#item0");
                        el.focus();

                    }
                }}
            />
            {
                visible &&
                <Callout
                    className={appStyles.costshareCallout}
                    gapSpace={2}
                    coverTarget={false}
                    onDismiss={ev => setVisible(false)}
                    // isBeakVisible={false}
                    beakWidth={0}
                    target={`#${id}`}
                    setInitialFocus
                >
                    {suggest()}
                </Callout>
            }

        </div >
    )
}

function mapStateToProps(state: RootState) { return { state } }
const connector = connect(mapStateToProps);
type TComponentConnectedProps = ConnectedProps<typeof connector>;
export default connector(AutoComplete)
